import axios from "axios";

// Determine the backend URL dynamically
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

class AuthManager {
  constructor() {
    this.listeners = [];
    this.session = null;
    
    // Load existing session from localStorage if available
    const saved = localStorage.getItem("recruitiq_session");
    if (saved) {
      try {
        this.session = JSON.parse(saved);
      } catch (e) {
        localStorage.removeItem("recruitiq_session");
        this.session = null;
      }
    }
  }

  async getSession() {
    return { data: { session: this.session }, error: null };
  }

  onAuthStateChange(callback) {
    const id = Math.random().toString(36).substring(2, 11);
    this.listeners.push({ id, callback });
    
    // Immediately call back with current state to trigger initial UI load
    callback("SIGNED_IN", this.session);
    
    return {
      data: {
        subscription: {
          unsubscribe: () => {
            this.listeners = this.listeners.filter((l) => l.id !== id);
          }
        }
      }
    };
  }

  _notifyChange(event) {
    this.listeners.forEach((l) => l.callback(event, this.session));
  }

  async signInWithPassword({ email, password }) {
    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        email,
        password
      });
      
      const { access_token, user } = response.data;
      
      // Mirror the session format expected by frontend
      this.session = {
        access_token,
        user: {
          id: user.id,
          email: user.email
        }
      };
      
      localStorage.setItem("recruitiq_session", JSON.stringify(this.session));
      this._notifyChange("SIGNED_IN");
      
      return { data: { session: this.session }, error: null };
    } catch (err) {
      const msg = err.response?.data?.detail || "Invalid login credentials.";
      return { data: { session: null }, error: new Error(msg) };
    }
  }

  async signUp({ email, password, options }) {
    try {
      const fullName = options?.data?.full_name || "";
      const orgName = options?.data?.org_name || "";
      
      const response = await axios.post(`${BACKEND_URL}/api/auth/register`, {
        email,
        password,
        full_name: fullName,
        org_name: orgName
      });
      
      const { user } = response.data;
      
      return { data: { user }, error: null };
    } catch (err) {
      const msg = err.response?.data?.detail || "Registration failed.";
      return { data: { user: null }, error: new Error(msg) };
    }
  }

  async signOut() {
    this.session = null;
    localStorage.removeItem("recruitiq_session");
    this._notifyChange("SIGNED_OUT");
    return { error: null };
  }
}

// Export the mock Supabase client wrapping our custom AuthManager
export const supabase = {
  auth: new AuthManager()
};
